import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MimeTypes} from '@shared/enums/mime-type.enum';
import * as moment from 'moment';
import {MomentDateFormat} from '@core/constant/system.constants';

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.css']
})
export class ImportDataComponent implements OnInit, OnChanges {
  @Input() title: string = "Import dữ liệu";
  @Input() fileName: string = "data_" + moment().format(MomentDateFormat.DATE_TIME_MILLISECONDS);
  @Input() fileTypes: string = [MimeTypes.xls, MimeTypes.xlsx].join(",");
  @Input() limitSize = 1024 * 100;
  @Input() importDone = false;
  @Output() process: EventEmitter<File> = new EventEmitter<File>();
  fileList: File[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  beforeUpload = (file: File): boolean => {
    this.fileList = [file];
    return false;
  };

  handleUpload() {
    if (this.fileList.length === 1)
      this.process.emit(this.fileList[0])
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.importDone) this.fileList = []
  }
}
